import { loadState, saveState } from './helpers';
import { profileSliceInitialState } from './slice';
import { createFetchProfileSummary, createRequestLogOutUser, createSignMessage } from './thunks';
const signMessage = createSignMessage();
const fetchProfileSummary = createFetchProfileSummary();
const requestLogOutUser = createRequestLogOutUser();
export const AUTH_PERSIST_KEY = 'isLoggedIn';
export const PROFILE_PERSIST_KEY = 'profile';
export const loadPersistedState = () => {
    const initialState = { ...profileSliceInitialState };
    const authState = loadState(AUTH_PERSIST_KEY);
    const profileDataState = loadState(PROFILE_PERSIST_KEY);
    if (authState) {
        initialState.isLoggedIn = authState;
    }
    if (profileDataState?.username) {
        initialState.username = profileDataState.username;
    }
    return { profile: initialState };
};
export const persistProfileState = (store) => (next) => (action) => {
    const prevState = store.getState();
    const returnValue = next(action);
    const nextState = store.getState();
    const shouldPersistAuthState = prevState.profile.isLoggedIn !== nextState.profile.isLoggedIn;
    const shouldPersistProfileData = 
    // @ts-expect-error to have correct type for action.meta, instead of `action: ProfileSliceActions` we need to have access full store's actions. specificly meta slice.
    (fetchProfileSummary.fulfilled.match(action) && !action.meta.arg.public) ||
        signMessage.fulfilled.match(action) ||
        requestLogOutUser.fulfilled.match(action);
    if (shouldPersistAuthState) {
        const state = store.getState().profile.isLoggedIn;
        saveState(AUTH_PERSIST_KEY, state);
    }
    if (shouldPersistProfileData) {
        const username = store.getState().profile.profileSummary.private.data?.username;
        saveState(PROFILE_PERSIST_KEY, { username });
    }
    return returnValue;
};
